import { useMediaQuery } from '@material-ui/core';
import { nanoid } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../App/redux/store';
import ActionNotification from '../components/Assets/ActionNotification';
import Footer from '../components/Assets/Footer';
import SelectInput from '../components/Forms/SelectInput';
import IndividualCircularLoader from '../components/Loader/IndividualCircularLoader';
import { sortSelectOptions } from '../features/folders/components/folderForm/form';
import FolderLine from '../features/folders/components/FolderLine';
import FoldersHeader from '../features/folders/components/FoldersHeader';
import useFolders from '../features/folders/useFolders';
import { modalsActions } from '../features/modals/modalsSlice';
import { APIStatus } from '../services/axiosEnums';
import { MEDIA_QUERY_MAX_768 } from '../shared/constants';
import genericSort from '../utils/genericSort';
import './styles/MyFolders.scss';

function FoldersPage() {
  const breakPoint = useMediaQuery(MEDIA_QUERY_MAX_768);
  const [sort, setSort] = useState('');
  const { folders } = useFolders({});
  const dispatch = useAppDispatch();
  const [activeFolder, setActiveFolder] = useState<IFolder | null>(null);

  const displayFooter = activeFolder && breakPoint;

  useEffect(() => {
    if (!breakPoint && activeFolder) {
      setActiveFolder(null);
    }
  }, [breakPoint]);

  const handleFolderDelete = (folder: IFolder | null) => {
    if (folder) {
      dispatch(modalsActions.deleteFolder(folder));
    }
  };

  const handleFolderUpdate = (folder: IFolder | null) => {
    if (folder) {
      dispatch(modalsActions.updateFolder(folder));
    }
  };

  const handleFolderIsActive = (folder: IFolder) => {
    setActiveFolder(folder.idIri === activeFolder?.idIri ? null : folder);
  };

  // default folder must be first in list
  const defaultFolder = folders.result?.find((elmt: any) => elmt.isDefault);
  // other folders filtered
  const othersFolders = genericSort(folders.result ?? [], 'asc', sort).filter(
    (elmt) => !elmt.isDefault,
  );
  return (
    <>
      <div className="my-folders">
        <FoldersHeader />

        <section className="my-folders-content">
          <ActionNotification />
          <div className="my-folders-content-actions">
            <p>{"Affiner l'affichage"}</p>
            <SelectInput
              name="sort"
              colorDisplay="reverse"
              nameKey="text"
              value={sort}
              handleChange={(e) => setSort(e.target.value)}
              label="Critère de tri"
              items={sortSelectOptions}
            />
          </div>

          {folders.apiStatus === APIStatus.PENDING ? (
            <IndividualCircularLoader
              size={200}
              className="my-folders-content-loader"
            />
          ) : (
            <table>
              <tbody>
                {defaultFolder && (
                  <FolderLine
                    key={nanoid()}
                    folder={defaultFolder}
                    activeFolder={activeFolder}
                    onFolderUpdate={handleFolderUpdate}
                  />
                )}

                {othersFolders?.map((elt) => (
                  <FolderLine
                    key={nanoid()}
                    activeFolder={activeFolder}
                    folder={elt}
                    onFolderUpdate={handleFolderUpdate}
                    onFolderDelete={handleFolderDelete}
                    onActiveFolder={handleFolderIsActive}
                  />
                ))}
              </tbody>
            </table>
          )}
        </section>
      </div>
      {displayFooter && (
        <Footer
          activeFolder={activeFolder}
          myFolders
          handleEdit={handleFolderUpdate}
          handleDelete={() => handleFolderDelete(activeFolder)}
        />
      )}
    </>
  );
}

export default FoldersPage;
